module.exports = __webpack_public_path__ + "static/media/longines.94db05c0.png";